export default {
  headers: [
    ['satellite-tracking/report.vehicle', 'vehicle'],
    ['satellite-tracking/report.expense_drivers', 'drivers'],
    ['satellite-tracking/report.distance', 'distance'],
    ['satellite-tracking/report.start_distance', 'startOdo'],
    ['satellite-tracking/report.end_distance', 'endOdo'],
    ['satellite-tracking/report.total_vehicle_expenses', 'totalVehicleExpenses'],
    ['satellite-tracking/report.expense_by_km', 'expenseByKm']
  ]
}
